// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"9eeb4ddd","432":"a6890cf3","920":"f735c533"}[chunkId] + ".chunk.css";
};